"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
exports.default = __1.TextInput;
//# sourceMappingURL=index.js.map